import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AppState } from '../../../../../../core/reducers';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { map } from 'rxjs/operators';
import {
  PractitionRole,
  PractitionRoleOnServerCreated,
  PractitionRoleOnServerUpdated,
  PractitionRoleService,
  selectErrorState,
  selectPractitionRoleById,
  selectPractitionRolesActionLoading,
  SharedHttpRequestService,
} from '../../../../../../core/lists';
import { currentUser } from 'src/app/core/auth';
import { TranslateService } from '@ngx-translate/core';
import { tagsViewContext } from '../../../../../../core/lists/_services/shared-http-request.service';
import { DatePipe, Location } from '@angular/common';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { remove } from 'lodash-es';

@Component({
  selector: 'kt-practition-role-edit',
  templateUrl: './practition-role-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PractitionRoleEditComponent implements OnInit, OnDestroy {
  practitionRole: PractitionRole;
  practitionRoleId$: Observable<number>;
  companyId: number;
  oldPractitionRole: PractitionRole;
  selectedTab = 0;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  practitionRoleForm: FormGroup;
  hasFormErrors = false;
  availableYears: number[] = [];
  private headerMargin: number;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  private subscriptions: any[] = [];
  tags = new FormControl();
  tags$ = new BehaviorSubject<any>([]);
  filteredCode;
  @ViewChild('codeInput') entityInput: ElementRef<HTMLInputElement>;
  codeList: any = [];
  filteredspecialty;
  @ViewChild('specialtyInput') entityInputspecialty: ElementRef<HTMLInputElement>;
  specialtyList: any = [];
  filteredHealth;
  @ViewChild('healthInput') entityInputHealth: ElementRef<HTMLInputElement>;
  healthList: any = [];
  // tslint:disable-next-line:variable-name
  doctor_id: number;
  dayIdForAdding: number;
  unassignedDays: any[] = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  availableStartTime;
  assignedTime = [];

  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private practitionRoleFB: FormBuilder,
    private layoutUtilsService: LayoutUtilsService,
    private practitionRoleService: PractitionRoleService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private sharedHttpRequestService: SharedHttpRequestService,
    public dialog: MatDialog,
    private _location: Location,
  ) {}

  ngOnInit() {
    const userSub = this.store.pipe(select(currentUser)).subscribe((res) => {
      if (!res) {
        this.router.navigateByUrl('/lists/doctors');
      }
      this.companyId = res !== undefined ? res.companyID : 1;
    });
    this.subscriptions.push({ id: 1, sub: userSub });
    this.loading$ = this.loadingSubject.asObservable();
    this.loadingSubject.next(true);
    const routeSub = this.activatedRoute.params.subscribe((params) => {
      const id = params.pra_id;
      this.doctor_id = params.id;

      if (id && id !== 0) {
        const practitionRoleSub = this.store
          .pipe(select(selectPractitionRoleById(id)))
          .subscribe((result) => {
            if (!result) {
              this.router.navigateByUrl('/lists/doctors');
              // this.loadPractitionRoleFromService(id);
              // return;
            }
            this.loadPractitionRole(result);
          });
        this.subscriptions.push({ id: 2, sub: practitionRoleSub });
      } else {
        const newPractitionRole = new PractitionRole();
        newPractitionRole.clear();
        this.loadPractitionRole(newPractitionRole);
      }
    });
    this.subscriptions.push({ id: 3, sub: routeSub });
    if (this.practitionRole.id > 0) this.loadTags();

    // sticky portlet header
    window.onload = () => {
      const style = getComputedStyle(document.getElementById('kt_header'));
      this.headerMargin = parseInt(style.height, 0);
    };
  }

  private loadTags() {
    this.sharedHttpRequestService
      .getTagsForView(this.practitionRole.id, tagsViewContext.ENTITIES)
      .subscribe((tags) => {
        this.tags$.next(tags.data);
      });
  }

  loadPractitionRole(_practitionRole, fromService = false) {
    if (!_practitionRole) {
      this.goBack();
      return;
    }
    this.practitionRole = _practitionRole;
    this.practitionRoleId$ = of(_practitionRole.id);
    this.oldPractitionRole = Object.assign({}, _practitionRole);
    this.initPractitionRole();
    if (fromService) {
      this.cdr.detectChanges();
    }
  }

  getTitle() {
    let result = this.translate.instant('PR.NEW_PR');
    if (!this.practitionRole || !this.practitionRole.id) {
      return result;
    }

    result =
      '<table><tr><td><div class="symbol symbol-100 mr-5" [hidden]="noimg"><div class="symbol-label div-of-img"><img src="./assets/media/users/300_21.jpg" style="max-width: 100% !important;border-radius: 100% !important" class="img-in-header-edit"></div><i class="symbol-badge bg-' +
      this.getItemCssClassByStatus(this.practitionRole.active) +
      ' status-in-edit-point"></td><td><h3>' +
      `${this.practitionRole.id}` +
      '</h3></td></tr></table>';
    return result;
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  initPractitionRole() {
    this.createForm();
    this.loadingSubject.next(false);
  }

  createForm() {
    this.practitionRoleForm = this.practitionRoleFB.group({
      active: [this.practitionRole.active],
      period_start: [
        this.practitionRole.period !== null && this.practitionRole.period['start'] !== ''
          ? this.practitionRole.period['start']
          : '',
        Validators.required,
      ],
      period_end: [
        this.practitionRole.period !== null && this.practitionRole.period['end'] !== ''
          ? this.practitionRole.period['end']
          : '',
        Validators.required,
      ],
      code: ['', Validators.required],
      specialty: ['', Validators.required],
      notAvailable_description: [
        this.practitionRole.notAvailable !== null &&
        this.practitionRole.notAvailable[0] !== undefined
          ? this.practitionRole.notAvailable[0].description
          : '',
        Validators.required,
      ],
      notAvailable_start: [
        this.practitionRole.notAvailable !== null &&
        this.practitionRole.notAvailable[0] !== undefined &&
        this.practitionRole.notAvailable[0]['during'] !== undefined
          ? this.practitionRole.notAvailable[0]['during'].start
          : '',
      ],
      notAvailable_end: [
        this.practitionRole.notAvailable !== null &&
        this.practitionRole.notAvailable[0] !== undefined &&
        this.practitionRole.notAvailable[0]['during'] !== undefined
          ? this.practitionRole.notAvailable[0]['during'].end
          : '',
      ],
      availabilityExceptions: [this.practitionRole.availabilityExceptions],
      daysOfWeek: [],
      availableStartTime: [],
      availableEndTime: [],
    });

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.practitionRole.availableTime.length; i++) {
      this.assignedTime.push({
        daysOfWeek: this.practitionRole.availableTime[i].daysOfWeek,
        availableStartTime: this.practitionRole.availableTime[i].availableStartTime,
        availableEndTime: this.practitionRole.availableTime[i].availableEndTime,
      });
    }
  }

  get f() {
    return this.practitionRoleForm.controls;
  }

  goBack() {
    this.loadingSubject.next(false);
    this._location.back();
  }

  goBackWithoutId() {
    this.loadingSubject.next(false);
    // this.router.navigateByUrl('/lists/practitionRoles');
  }

  reset() {
    this.practitionRole = Object.assign({}, this.oldPractitionRole);
    this.createForm();
    this.hasFormErrors = false;
    this.practitionRoleForm.markAsPristine();
    this.practitionRoleForm.markAsUntouched();
    this.practitionRoleForm.updateValueAndValidity();
  }

  onSumbit() {
    this.hasFormErrors = false;
    const controls = this.practitionRoleForm.controls;
    if (this.practitionRoleForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());

      this.hasFormErrors = true;
      this.selectedTab = 0;
      return;
    }

    // tslint:disable-next-line:prefer-const
    const editedPractitionRole = this.preparePractitionRole();
    if (editedPractitionRole.id !== 0) {
      this.updatePractitionRole(editedPractitionRole);
      return;
    }

    this.addPractitionRole(editedPractitionRole);
  }

  preparePractitionRole(): PractitionRole {
    const controls = this.practitionRoleForm.controls;
    const _practitionRole = new PractitionRole();
    _practitionRole.clear();
    _practitionRole.active = controls.active.value;
    _practitionRole.period_start = this.datePipe.transform(
      controls.period_start.value,
      'yyyy-MM-dd',
    );
    _practitionRole.period_end = this.datePipe.transform(controls.period_end.value, 'yyyy-MM-dd');
    _practitionRole.code = controls.code.value;
    _practitionRole.id = this.practitionRole.id;
    _practitionRole.specialty = controls.specialty.value;
    _practitionRole.notAvailable_description = controls.notAvailable_description.value;
    _practitionRole.notAvailable_during_start = this.datePipe.transform(
      controls.notAvailable_start.value,
      'yyyy-MM-dd',
    );
    _practitionRole.notAvailable_during_end = this.datePipe.transform(
      controls.notAvailable_end.value,
      'yyyy-MM-dd',
    );
    _practitionRole.availabilityExceptions = controls.availabilityExceptions.value;
    // _practitionRole.healthcareService = controls.healthcareService.value
    _practitionRole.doctor_id = this.doctor_id;
    _practitionRole.daysOfWeek = controls.daysOfWeek.value;
    _practitionRole.availableStartTime = controls.availableStartTime.value;
    _practitionRole.availableEndTime = controls.availableEndTime.value;
    _practitionRole.availableTime = this.assignedTime;
    for (const [key, value] of Object.entries(_practitionRole)) {
      if (typeof value === 'string') {
        _practitionRole[key] = value.trim();
      }
    }
    return _practitionRole;
  }

  addPractitionRole(_practitionRole: PractitionRole) {
    this.loadingSubject.next(true);
    this.store.dispatch(new PractitionRoleOnServerCreated({ practitionRole: _practitionRole }));
    if (this.subscriptions.find((sub) => sub.id === 4) === undefined) {
      const actionLoadingSubscription = this.store
        .pipe(select(selectPractitionRolesActionLoading))
        .subscribe((res) => {
          if (res !== true) {
            this.loadingSubject.next(false);
            if (this.subscriptions.find((sub) => sub.id === 5) === undefined) {
              const errorStateSubscription = this.store
                .pipe(select(selectErrorState))
                .subscribe((error) => {
                  if (error) {
                    if (error.error && error.error.errors) {
                      this.submissionErrorObj = error.error.errors;
                    } else {
                      this.submissionErrorObj = [{ error: 'GLOBAL.UNSPECIFIED_ERROR' }];
                    }
                    this.hasSubmissionErrors = true;
                  } else if (this.router.routerState.snapshot.url !== '/lists/doctors') {
                    this.submissionErrorObj = null;
                    this.hasSubmissionErrors = false;
                    const message = this.translate.instant('PR.ADDED');
                    this.layoutUtilsService.showActionNotification(
                      message,
                      MessageType.Create,
                      3000,
                      false,
                      false,
                    );
                    this.goBack();
                  }
                });
              this.subscriptions.push({ id: 5, sub: errorStateSubscription });
            }
          }
          this.cdr.detectChanges();
        });
      this.subscriptions.push({ id: 4, sub: actionLoadingSubscription });
    }
  }

  updatePractitionRole(_practitionRole: PractitionRole) {
    this.loadingSubject.next(true);

    const updatePractitionRole: Update<PractitionRole> = {
      id: _practitionRole.id,
      changes: _practitionRole,
    };

    this.store.dispatch(
      new PractitionRoleOnServerUpdated({
        partialPractitionRole: updatePractitionRole,
        practitionRole: _practitionRole,
      }),
    );
    if (this.subscriptions.find((sub) => sub.id === 6) === undefined) {
      const actionLoadingSubscription = this.store
        .pipe(select(selectPractitionRolesActionLoading))
        .subscribe((res) => {
          if (res !== true) {
            this.loadingSubject.next(false);
            if (this.subscriptions.find((sub) => sub.id === 7) === undefined) {
              const errorStateSubscription = this.store
                .pipe(select(selectErrorState))
                .subscribe((error) => {
                  if (error) {
                    if (error.error && error.error.errors) {
                      this.submissionErrorObj = error.error.errors;
                    } else {
                      this.submissionErrorObj = [{ error: 'GLOBAL.UNSPECIFIED_ERROR' }];
                    }
                    this.hasSubmissionErrors = true;
                  } else if (this.router.routerState.snapshot.url !== '/lists/doctors') {
                    this.goBack();
                    const message = this.translate.instant('PR.UPDATED');
                    this.layoutUtilsService.showActionNotification(
                      message,
                      MessageType.Update,
                      3000,
                      false,
                      false,
                    );
                  }
                });
              this.subscriptions.push({ id: 7, sub: errorStateSubscription });
            }
          }
          this.cdr.detectChanges();
        });
      this.subscriptions.push({ id: 6, sub: actionLoadingSubscription });
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.practitionRoleForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  getComponentTitle() {
    let result = this.translate.instant('PR.NEW_PR');
    if (!this.practitionRole || !this.practitionRole.id) {
      return result;
    } else if (this.activatedRoute.url[`_value`][1]?.path === 'view') {
      result = `${this.translate.instant('PR.VIEW_PR')} - ${this.practitionRole.id}`;
      return result;
    }

    result = `${this.translate.instant('PR.EDIT_PR')} - ${this.practitionRole.id}`;
    return result;
  }

  getImg() {
    let result = './assets/media/users/300_21.jpg';
    if (!this.practitionRole || !this.practitionRole.id) {
      return result;
    }

    result = './assets/media/users/300_21.jpg';
    return result;
  }

  onAlertClose() {
    this.hasFormErrors = false;
  }

  getStatusString(): string {
    switch (this.practitionRoleForm.get('active').value) {
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
    }
    return '';
  }

  getItemCssClassByStatus(status: boolean): string {
    switch (status) {
      case false:
        return 'danger';
      case true:
        return 'success';
    }
    return '';
  }

  getItemStatusString(status: boolean): string {
    switch (status) {
      case false:
        return 'inActive';
      case true:
        return 'Active';
      default:
        return '';
    }
  }

  selectedCode(event: MatAutocompleteSelectedEvent): void {
    this.codeList.push(event.option.value);
    this.entityInput.nativeElement.value = event.option.value.concept.fsn.term;
  }

  codeInputChanged(value) {
    if (value) {
      if (typeof value === 'string')
        this.filteredCode = this.practitionRoleService.searchCode(value).pipe(
          map((res) =>
            res.items.filter((r) => {
              return !this.codeList.find((e: any) => e.concept.id === r.concept.id);
            }),
          ),
        );
    } else {
      this.filteredCode = of([]);
    }
  }

  displayFnCode(event: any): string {
    return event && event.concept.fsn.term ? event.concept.fsn.term : '';
  }

  selectedspecialty(event: MatAutocompleteSelectedEvent): void {
    this.specialtyList.push(event.option.value);
    this.entityInputspecialty.nativeElement.value = event.option.value.concept.fsn.term;
  }

  specialtyInputChanged(value) {
    if (value) {
      if (typeof value === 'string')
        this.filteredspecialty = this.practitionRoleService.searchCode(value).pipe(
          map((res) =>
            res.items.filter((r) => {
              return !this.specialtyList.find((e: any) => e.concept.id === r.concept.id);
            }),
          ),
        );
    } else {
      this.filteredspecialty = of([]);
    }
  }

  displayFnspecialty(event: any): string {
    return event && event.concept.fsn.term ? event.concept.fsn.term : '';
  }

  selectedHealth(event: MatAutocompleteSelectedEvent): void {
    this.specialtyList.push(event.option.value);
    this.entityInputHealth.nativeElement.value = event.option.value.name;
  }

  healthInputChanged(value) {
    const olives = [];
    this.practitionRoleService.searchHealth(value).subscribe((res) => {
      for (let i = 0; res.entry.length > i; i++) {
        olives.push(res.entry[i].resource);
      }
      if (value) {
        if (typeof value === 'string')
          this.filteredHealth = olives.filter((r) => {
            return !this.healthList.find((e: any) => e.id === r.id);
          });
      } else {
        this.filteredHealth = [];
      }
    });
  }

  displayFnHealth(event: any): string {
    return event && event.concept.fsn.term ? event.concept.fsn.term : '';
  }

  assignTime() {
    const controls = this.practitionRoleForm.controls;

    if (
      !controls.availableStartTime.value ||
      !controls.availableEndTime.value ||
      controls.daysOfWeek.value === undefined
    ) {
      return;
    }

    this.assignedTime.push({
      daysOfWeek: controls.daysOfWeek.value,
      // tslint:disable-next-line:max-line-length
      availableStartTime:
        (
          '0' +
          (controls.availableStartTime.value != null
            ? controls.availableStartTime.value['hour']
            : '00')
        ).slice(-2) +
        ':' +
        (
          '0' +
          (controls.availableStartTime.value != null
            ? controls.availableStartTime.value['minute']
            : '00')
        ).slice(-2) +
        ':00',
      // tslint:disable-next-line:max-line-length
      availableEndTime:
        (
          '0' +
          (controls.availableEndTime.value != null ? controls.availableEndTime.value['hour'] : '00')
        ).slice(-2) +
        ':' +
        (
          '0' +
          (controls.availableEndTime.value != null
            ? controls.availableEndTime.value['minute']
            : '00')
        ).slice(-2) +
        ':00',
    });
  }

  unassingTime(time: any) {
    // this.unassignedTimes.push(time);
    remove(this.assignedTime, (el) => el === time);
  }
}
